export const FETCH_TAX_CONDITIONS = 'publicador/seekerGuard/FETCH_TAX_CONDITIONS';
export const CONVERT_SEEKER_TO_PUBLISHER = 'publicador/seekerGuard/CONVERT_SEEKER_TO_PUBLISHER';
export const SET_MOBILE_PHONE = 'publicador/seekerGuard/SET_MOBILE_PHONE';
export const SET_TAX_CONDITIONS = 'publicador/seekerGuard/SET_TAX_CONDITIONS';
